import $ from 'jquery';

import './lib.scss';

window.jQuery = $;

$('document').ready(function () {
});



// WEBPACK FOOTER //
// ./src/assets/lib/lib.js